import React from 'react';
import { Button } from '~/components/ui/Button';
import { cn } from '~/helpers/utils';
import { faBarsFilter } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type OpenFiltersButtonProps = {
  open: boolean;
  setOpen: (val: boolean) => void;
};

const OpenFiltersButton: React.FC<OpenFiltersButtonProps> = ({ open, setOpen }) => {
  return (
    <div className={cn(
      'sticky left-0 w-full bottom-0 z-20 bg-white pt-4 pb-4 px-6',
      'shadow-[0_-3px_6px_0_rgba(0,0,0,0.3)]',
      'md:hidden'
    )}>
      <Button
        type="button"
        variant="secondary"
        onClick={() => setOpen(!open)}
      >
        <FontAwesomeIcon icon={faBarsFilter} className="text-blue" />
        Filters {open ? 'sluiten' : 'openen'}
      </Button>
    </div>
  );
};

export default OpenFiltersButton;